import Vue from 'vue';
import Router from 'vue-router';
import dashboard from '@/view/dashboard';
import play from '@/view/videos';
import cloud from '@/view/cloud';
import user from '@/api/user';
import store from '@/store';
import userView from '@/view/user';
import page404 from '@/view/404';
import homepage from '@/view/homepage';
import ShoppingCart from '@/view/cart/';
import cart from '@/view/cart/cart';
import orderComplete from '@/view/cart/orderComplete';
import paymentCallback from '@/view/callback/payment';
import nprogress from 'nprogress';
import PlanCancel from '@/view/cancelPlans/';
import cancelPlan from '@/view/cancelPlans/cancelPlan';
import cancelPlanComplete from '@/view/cancelPlans/cancelPlanComplete';
import paymentHistory from '@/view/paymentHistory';
// 切换套餐成功
import switchSuccess from '@/view/switchSuccess';
import subscribePlan from '@/view/cloud/subscribePlan';
import updatePlan from '@/view/updatePlan';
import invoice from '@/view/paymentHistory/invoice';
import { config } from 'CONFIG';
import { headerHandle } from '@/common/js/header';
import reolinkGa from '@/common/js/gtagPageview';
// 分享
import share from '@/view/share/index';
import shareList from '@/view/share/shareList';
import shareDel from '@/view/share/shareDelete';
import shareAuth from '@/view/share/shareAuth';
import installGuide from '@/view/share/installGuide';
import codeExpried from '@/view/share/codeExpried';
import addSharedDevice from '@/view/share/addSharedDevice';
import generateCode from '@/view/share/generateCode';

Vue.use( Router );

const router = new Router({
    mode: 'history',
    scrollBehavior ( to ) {

        if ( to.hash ) {

            return {

                selector: to.hash

            };

        }

    },
    routes: [
        {
            path: '/user/',
            component: userView,
            redirect: '/user/dashboard/',
            children: [
                {
                    path: 'dashboard/',
                    name: 'dashboard',
                    component: dashboard,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'play/',
                    name: 'play',
                    component: play,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'cloud-library/',
                    name: 'library',
                    component: cloud,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'subscribe-plan/',
                    name: 'subscribePlan',
                    component: subscribePlan,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'cloud-plan-payment-history/',
                    name: 'cloudPlanPaymentHistory',
                    component: paymentHistory,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'update-plan/',
                    component: updatePlan,
                    name: 'updatePlan',
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'invoice/:id/',
                    component: invoice,
                    name: 'invoice',
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: '/user/cancel-plan/',
                    component: PlanCancel,
                    children: [
                        {
                            path: '/',
                            name: 'cancelPlan',
                            component: cancelPlan,
                            meta: {

                                requiresAuth: true

                            }

                        },
                        {
                            path: 'complete/',
                            name: 'cancelPlanComplete',
                            component: cancelPlanComplete,
                            meta: {

                                requiresAuth: true

                            }
                        }
                    ]
                }
            ]
        },
        {
            path: '/',
            name: 'homepage',
            component: homepage
        },
        {
            path: '/checkout/processing/',
            name: 'paymentCallback',
            component: paymentCallback
        },
        {
            path: '/checkout/',
            component: ShoppingCart,
            children: [
                {
                    path: '/',
                    name: 'cart',
                    component: cart,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'payment-complete/',
                    name: 'orderComplete',
                    component: orderComplete,
                    meta: {

                        requiresAuth: true

                    }
                }
            ]
        },
        {
            path: '*',
            name: '404',
            component: page404
        },
        {
            path: '/user/complete/',
            name: 'switchSuccess',
            component: switchSuccess,
            meta: {

                requiresAuth: true

            }

        },
        {
            path: '/share/',
            name: 'shareList',
            component: share,
            redirect: '/share/sharelist/',
            children: [
                {
                    path: 'sharelist/',
                    name: 'sharelist',
                    component: shareList,
                    meta: {

                        requiresAuth: true,
                        bodyBackground: '#F7F8F9'

                    }
                },
                {
                    path: 'sharedelete/',
                    name: 'sharedelete',
                    component: shareDel,
                    meta: {

                        requiresAuth: true,
                        bodyBackground: '#F7F8F9'

                    }
                },
                {
                    path: 'shareauth/:uid',
                    name: 'shareauth',
                    component: shareAuth,
                    meta: {

                        requiresAuth: true,
                        bodyBackground: '#F7F8F9'

                    }
                },
                {
                    path: 'install-guide/',
                    name: 'installGuide',
                    component: installGuide,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'code-expried/',
                    name: 'codeExpried',
                    component: codeExpried,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'add-shared-device/',
                    name: 'addSharedDevice',
                    component: addSharedDevice,
                    meta: {

                        requiresAuth: true

                    }
                },
                {
                    path: 'generateCode/',
                    name: 'generateCode',
                    component: generateCode,
                    meta: {

                        requiresAuth: true,
                        bodyBackground: '#F7F8F9'

                    }
                }
            ]
        }
    ]
});

let hasFetchedProfile = false;

const handle = async ( requiresAuth ) => {

    store.commit( 'STATUS_CHANGE', 'handling' );
    let logined;
    if ( config.platform === 'web' ) {

        logined = await user.login( requiresAuth );

    } else {

        logined = true;

    }
    nprogress.set( 0.5 );
    store.commit( 'PAGESKIP' );
    store.dispatch( 'closeTopInfo' );
    // 在web页面时，每次跳转都请求用户信息
    // 在webview时，只请求一次用户信息
    if ( logined ) {

        if ( config.platform === 'web' ) {

            await user.getUserInfo();

        } else if ( !hasFetchedProfile ) {

            await user.getUserInfo();
            hasFetchedProfile = true;

        }
        nprogress.done();
        store.commit( 'STATUS_CHANGE', 'logined' );
        return true;

    } else {

        store.commit( 'STATUS_CHANGE', 'notLogined' );
        if ( requiresAuth ) {

            return false;

        } else {

            nprogress.done();
            return true;

        }

    }

};

router.beforeEach( async ( to, from, next ) => {

    nprogress.start();
    let requiresAuth = to.meta.requiresAuth;
    if ( requiresAuth ) {

        let suc = await handle( requiresAuth );
        if ( suc ) {

            headerHandle( to );
            window.scrollTo( 0, 0 );
            next();

        }

    } else {

        if ( to.name === 'homepage' ) {

            await handle( requiresAuth );
            headerHandle( to );
            window.scrollTo( 0, 0 );
            next();

        } else {

            headerHandle( to );
            window.scrollTo( 0, 0 );
            next();
            await handle( requiresAuth );

        }

    }

    let bodyBackground = to.meta.bodyBackground;
    if ( bodyBackground ) {

        $( 'body' ).css( 'background-color', bodyBackground );

    }

    if ( config.client === 'IOS' ) {

        $( 'body' ).addClass( 'ios' );

    } else if ( config.client === 'Android' ) {

        $( 'body' ).addClass( 'android' );

    }

});

router.afterEach( to => {

    if ( !config.featrue.disabled.includes( 'cloud.gtag' )) {

        reolinkGa.updateLocation( to.name, to.path );
        reolinkGa.pageview( to.name );

    }

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js